import React, {Component} from "react";
import {Header} from "../general/Header";
import {Footer} from "../general/Footer";
import ReactPlayer from "react-player";

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This class displays a video that shows the user what an unsuccessful delivery means to the environment
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export default class UnsuccessfulDelivery extends Component<any> {
  render() {
    return (
      <div>
        <Header />

        <div className={"video_viewer"}>
          <ReactPlayer
            url={
              "https://firebasestorage.googleapis.com/v0/b/kuehnected.appspot.com/o/video.mp4?alt=media&token=ce38d20a-6fdf-4e07-a72f-a83f29c9ffa5"
            }
            playing
            width={"100%"}
            height={"auto"}
          />
        </div>
        <Footer />
      </div>
    );
  }
}
